export default {
    change_sim_provider_title: "Cambiar la Cuenta del Proveedor de Sim",
    change_sim_provider_label: "Proveedor de Simsr",
    change_sim_provider_account_label: "Cuenta del proveedor Sim",
    change_sim_provider_input: "IMEI o serie",
    change_sim_provider_imei: "IMEI",
    change_sim_provider_serial: "Serie",
    change_sim_provider_model: "Modelo",
    change_sim_provider_change: "Cambiar",
    change_sim_provider_no_devices_added: "No se han añadido dispositivos",
    change_sim_provider_device_is_already_added: "El dispositivo ya está añadido",
    change_sim_provider_device_has_not_been_found: "No se ha encontrado el dispositivo",
    change_sim_provider_this_feature_is_not_available: "Esta función no está disponible",
    change_sim_provider_single_success_message: "La cuenta del proveedor de Sim del dispositivo ha sido cambiada",
    change_sim_provider_multiple_success_message: "Se ha actualizado la cuenta del proveedor de Sim de los dispositivos",
    change_sim_provider_error_message: "No se puede cambiar la cuenta del proveedor de SIM debido a un error",
    change_sim_provider_message: "La solicitud para cambiar la cuenta del proveedor de SIM ha sido enviada con éxito, por favor revise la lista de transacciones para ver el estado de la solicitud.",
}